/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CampaignWrapperListEntryFromJSON, CampaignWrapperListEntryToJSON, } from './CampaignWrapperListEntry';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
/**
 * Check if a given object implements the PagedResponseOfCampaignWrapperListEntry interface.
 */
export function instanceOfPagedResponseOfCampaignWrapperListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfCampaignWrapperListEntryFromJSON(json) {
    return PagedResponseOfCampaignWrapperListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfCampaignWrapperListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'page': !exists(json, 'page') ? undefined : json['page'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(CampaignWrapperListEntryFromJSON)),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious']
    };
}
export function PagedResponseOfCampaignWrapperListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'page': value.page,
        'hasNext': value.hasNext,
        'numberOfElements': value.numberOfElements,
        'size': value.size,
        'nextPage': PageRequestToJSON(value.nextPage),
        'previousPage': PageRequestToJSON(value.previousPage),
        'metaData': MetaDataToJSON(value.metaData),
        'entries': value.entries === undefined ? undefined : (value.entries.map(CampaignWrapperListEntryToJSON)),
        'totalElements': value.totalElements,
        'hasPrevious': value.hasPrevious
    };
}
